import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotHeartCross = ({
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Size=40,_Spot=On_svg__a)">
            <path
                fill={spotColor}
                d="M4.857 17.78c1.738-5.087 7.916-9.787 13.373-11.594 5.482-1.818 11.979-.362 16.283 3.888 4.304 4.25 6.402 10.611 5.107 15.97-1.26 5.374-5.757 8.608-9.715 10.583-3.983 1.985-7.428 1.992-11.538.997-4.123-.96-8.301-2.541-10.448-6.26-2.147-3.72-4.824-8.487-3.062-13.584Z"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M35 10.626a8.418 8.418 0 0 0-15.762-.319A8.417 8.417 0 0 0 3 13.424c0 4.259 2.69 9.036 8.044 14.22a60.788 60.788 0 0 0 7.982 6.442.384.384 0 0 0 .42 0s.787-.382 2.82-1.989M26.129 13h5.744v5.128H37v5.744h-5.128v5.129h-5.744v-5.129H21v-5.744h5.128V13Z"
            />
        </g>
        <defs>
            <clipPath id="Size=40,_Spot=On_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotHeartCross.displayName = "SpotHeartCross";
